import { render, staticRenderFns } from "./SdCopyToClipboard.vue?vue&type=template&id=199fb362&scoped=true&"
import script from "./SdCopyToClipboard.vue?vue&type=script&lang=js&"
export * from "./SdCopyToClipboard.vue?vue&type=script&lang=js&"
import style0 from "./SdCopyToClipboard.vue?vue&type=style&index=0&id=199fb362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199fb362",
  null
  
)

component.options.__file = "SdCopyToClipboard.vue"
export default component.exports